






























import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import Amount from '@/componentsV2/molecules/Amount/Amount.vue';
import { SmartBusinessSignupData } from '@/models/smart-business-signup';

import SectionHeader from './SectionHeader.vue';
import segmentIo from '@/utils/segment.io';
import { debounce } from 'lodash';

const ON_CHANGE_KEY = 'loyaltyPercentageRecommendation';

@Component({
  components: {
    Typography,
    SectionHeader,
    Amount
  }
})
export default class Loyalty extends Vue {
  @Prop() readonly defaultSelectedValue!: number | null;
  @Prop() readonly defaultValues!: [number, string][];

  customValue: number | null = this.customValueData;
  selectedIndex: number | null =
    this.defaultSelectedValue &&
    this.defaultValues.findIndex(val => val[0] === this.defaultSelectedValue);
  formData = this.smartBusinessSignupData.loyaltyPercentageRecommendation;

  get smartBusinessSignupData(): SmartBusinessSignupData {
    return this.$store.getters['businessOnboarding/getSmartBusinessSignup'];
  }

  get customValueData() {
    if (
      !this.defaultValues
        .map(item => item[0])
        .includes(
          this.smartBusinessSignupData.loyaltyPercentageRecommendation
            .percentage
        )
    ) {
      return this.smartBusinessSignupData.loyaltyPercentageRecommendation
        .percentage;
    }
    return null;
  }

  @Watch('formData', { deep: true })
  onChangeEmit() {
    this.$emit('onChange', this.formData, ON_CHANGE_KEY);
  }

  changeEnable(value: boolean) {
    this.formData.enabled = value;
    segmentIo.track('AI Sign Up | Loyalty Activation Toggle', {
      Enabled: value
    });
  }

  handleInput(value: number) {
    this.customValue = value;
    this.formData.percentage = value;
    this.selectedIndex = null;
    debounce(() => {
      segmentIo.track('AI Sign Up | Custom Rewards Rate Selected', {
        Percentage: value
      });
    }, 1000);
  }

  handleClick(value: number, type: string, index: number) {
    if (type === 'custom') {
      this.selectedIndex = null;
      return;
    }
    this.customValue = null;
    this.selectedIndex = index;
    this.formData.percentage = value;

    segmentIo.track('AI Sign Up | Rewards Rate Selected', {
      Percentage: value
    });
  }
}
